import { z, ZodIssueCode } from 'zod';
const parseJsonPreprocessor = (value, ctx) => {
    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        }
        catch (e) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: e.message,
            });
        }
    }
    return value;
};
export const FIND_RELEVANT_CODEBASE_FILES_FUNCTION = 'find_relevant_codebase_files';
const findRelevantCodebaseFilesShapeSchema = z.object({
    fullTextQuestion: z.string(),
    message: z.string().optional(),
    uniqueCodebaseFiles: z.array(z.string()).optional(),
});
export const findRelevantCodebaseFilesSchema = z.preprocess(parseJsonPreprocessor, findRelevantCodebaseFilesShapeSchema);
export const FIND_RELEVANT_CODE_RECIPES_FUNCTION = 'find_relevant_code_recipes';
const findRelevantCodeRecipesShapeSchema = z.object({
    fullTextQuestion: z.string(),
    message: z.string().optional(),
    sortedRecipes: z.array(z.string()).optional(),
});
export const findRelevantCodeRecipesSchema = z.preprocess(parseJsonPreprocessor, findRelevantCodeRecipesShapeSchema);
export const FIND_SCHEMA_ENTITIES_FUNCTION = 'find_database_schema';
const findSchemaEntitiesShapeSchema = z.object({
    message: z.string().optional(),
    entities: z.array(z.string()).optional(),
    enums: z.array(z.string()).optional(),
    files: z.array(z.string()).optional(),
});
export const findSchemaEntitiesSchema = z.preprocess(parseJsonPreprocessor, findSchemaEntitiesShapeSchema);
export const FILE_READ_FUNCTION = 'read_file';
const fileReadShapeSchema = z.object({
    filePath: z.string(),
    message: z.string().optional(),
    fileContentAsBase64: z.string().optional(),
});
export const fileReadSchema = z.preprocess(parseJsonPreprocessor, fileReadShapeSchema);
export const FILE_CREATION_FUNCTION = 'create_file';
export const fileCreateSchema = z.object({
    filePath: z.string(),
    message: z.string().optional(),
    fileContentAsBase64: z.string().optional(),
    diffAsBase64: z.string().optional(),
});
export const FILE_DELETION_FUNCTION = 'delete_file';
export const fileDeleteSchema = z.object({
    filePath: z.string(),
    message: z.string().optional(),
    fileContentAsBase64: z.string().optional(),
    diffAsBase64: z.string().optional(),
});
export const FILE_UPDATE_FUNCTION = 'update_file';
export const fileUpdateSchema = z.object({
    filePath: z.string(),
    message: z.string().optional(),
    fileContentAsBase64: z.string().optional(),
});
export const APPLY_FILE_CHANGES_FUNCTION = 'apply_file_changes';
export const applyFileChangesSchema = z.object({
    filePath: z.string(),
    message: z.string().optional(),
    fileContentAsBase64: z.string().optional(),
    diffAsBase64: z.string().optional(),
    fileIsModel: z.boolean(),
});
//# sourceMappingURL=conts.js.map